//  normal Categories
export interface ICategory {
   _id: string,
   category_icon: string;
   category_name: string;
   position: string;
   type: string;
   updatedAt?: string;
}
export interface ILocation {
   country: string,
   state: string,
   city: string,
   lat: number,
   long: number,
   street?: string,
   landmark?: string,
   pin_code: string,
   location: {
      type: string;
      coordinates: [number, number];
   };
};



//  Doorstep Categories
export interface IDoorstepCategory {
   category_name: string;
   createdAt: string;
   description: string;
   icon: string | null;
   provider: string[];
   _id: string;

};

//  normal sub Categories
export interface ISubCategory {
   _id: string,
   category_id: string,
   sub_category_icon: string;
   sub_category_name: string;
   category_name: string;
   createdAt?: string;
   type: string;
}

export interface IBankDetails {
   account_holder_name: string;
   bank_name: string;
   account_number: string;
   IFSC_code: string;

}

//  Worker interface
export interface IWorker {
   _id: string;
   phone: string;
   has_firm: boolean;
   createdAt: string;
   dial_code: string;
   has_membership: boolean;
   has_subscription: boolean;
   is_activated_account: boolean;
   is_basic_details_completed: boolean;
   razorpay_contact_id?: string;
   is_deleted: boolean;
   is_document_details_completed: boolean;
   is_membership_details_completed: boolean;
   is_online: boolean;
   is_otp_verified: boolean;
   is_question_ans_completed: boolean;
   is_verified: boolean;
   otp: string;
   my_referral: string;
   role: 'worker' | 'other_roles_if_any'; // Extend roles as needed
   specification: string[];
   updatedAt: string;
   you_are_a: string[];
   your_work: string[]; // Array of URLs
   address: ILocation;
   alternate_number: string;
   bio: string;
   date_of_birth: string; // Date string
   gender: 'Male' | 'Female' | 'Other'; // Extend genders as needed
   name: string;
   profile_pic: null | string; // URL string
   qualification: string;
   referral_code: string;
   sub_worker_type: string[];
   worker_type: string;
   bank_details: IBankDetails;
   firm_name: string;
   type_of_business?: string;
   document_details: {
      category: string,
      adhaar_number: string;
      pan_number: string;
      worker_specialization: string[];
      firm_age: string;
      firm_gst_number: string;
      firm_pan_number: string;
      firm_gst_pic: string;
      firm_pan_pic: string;
      adhaar_front_pic: string;
      adhaar_back_pic: string;
      seller_shop_pic1: string,
      seller_shop_pic2: string,
      pan_front_pic: string;
      more_areas_served: string,
   };
   walletAmount: number;
}

//  Doorstep service
export interface IService {
   _id: string;
   about: string;
   category_name: string;
   createdAt: string; // Consider using Date type if you need date manipulation
   description: string[];
   doorstep_category_id: string;
   price_per_half_hour: number;
   price_per_hour: number;
   service_image: string;
   service_providers: string[];
   service_title: string;
   service_type: string;
   updatedAt: string; // Consider using Date type if you need date manipulation
   __v: number;
}

export interface IProfessionalService {

   _id: string;
   description: string[];
   service_providers: any[];
   worker_category_id: string;
   category_name: string;
   service_title: string;
   service_image: string;
   price: number;
   about: string;
   worker_type: string;
   service_type: string;
   createdAt: string;
   is_count: boolean;
   is_deleted: boolean;
   working_basis: string;
   advance_booking?: boolean;
   price_per_half_hour: number
   hours_count: number;

}
//  Location / address interface


//  Doorstep service Billing Details
export interface IBillingDetails {
   service_charges: number,
   convenience_charges: number,
   tax: number,
   total_amount: number,
   additional_working_mins?: number,
   additional_working_charges?: number
   additional_convenience_charges?: number;
   additional_service_charges?: number;
   additional_tax?: number;

}
//  Doorstep order interfaces ================================================

interface Address {
   street?: string;
   country: string;
   state: string;
   city: string;
   lat: number;
   long: number;
   pin_code: string;

}

interface BillingDetails {
   service_charges: number;
   convenience_charges: number;
   tax: number;
   total_amount: number;
   additional_working_charges: number;
   additional_working_mins: number;

   promo_code?: string,
   promo_percentage?: number,
   promo_amount?: number,
   additional_convenience_charges?: number,
   additional_service_charges?: number,
   additional_tax?: number,

   // commisions
   //company commision
   yows_comm_inc_gst: number;
   yows_comm_exc_gst: number;
   gst_on_yows_comm: number;
   add_yows_comm_exc_gst?: number;
   add_yows_comm_inc_gst?: number;
   add_gst_on_yows_comm?: number;
   // worker commision
   worker_comm_exc_gst?: number;
   worker_comm_inc_gst?: number;
   worker_comm: number;
   gst_on_worker_comm: number;
   tcs_amt: number;

   add_gst_on_worker_comm?: number;

   add_tcs_amt?: number;
   add_worker_comm_exc_gst?: number;
   add_worker_comm_inc_gst?: number;
   add_worker_comm: number;

}

interface ServiceDetails {
   title: string;
   price_per_half_hour: number;
   price_per_hour: number;
   service_image: string;
   price: number;

}

interface UserDetails {
   name: string;
   phone: string;
   profile_pic: string;

}

interface WorkerDetails {
   name: string;
   phone: string;
   profile_pic: string;
   worker_type: string;
   is_verified: boolean;
}

export interface IServiceOrder {
   _id: string;
   assigned_worker: string;
   address: Address;
   billing_details: BillingDetails;
   createdAt: string;
   date_time: string;
   end_time: string;
   order_type: string;
   user_id: string;
   otp: string;
   payment_id: string;
   payment_order_id: string;
   serviceDetails: ServiceDetails;
   start_time: string;
   status: string;
   service_title: string;
   service_category: string;
   service_count: number;
   service_id: string;
   service_providers: string[];
   unique_code: string;
   updatedAt: string;
   sub_type: string[];
   userDetails: UserDetails;
   unique_id: string;
   workerDetails?: WorkerDetails;
   __v: number;
   payment_status: boolean;
   promo_code?: string;
}


// requirements Billing Details
export interface IRequirementBillingDetails {

   tax_percentage: string,
   post_charges: number;
   tax: number;
   total: number;
}

// requirement interface
export interface IRequirement {
   _id: string,
   type: string; // 'work', 'material', or 'job'
   address: ILocation;
   description: string;
   work_requirement?: string[];
   material_requirement?: {
      materialName: string;
      brandName: string;
      quantityType: string;
      qty: string;
      unit?: string;
   }[];
   hiring_type?: string[];
   payment_id: string,
   payment_order_id: string,
   signature: string,
   salary_offered?: string;
   approx_area?: string;
   estimated_budget?: string;
   urgent_looking?: string;
   alternate_address?: string,
   unique_id: string,
   unique_code: string,
   vacancy_count: number,
   hiring_for: string,
   firm_name: string,
   gst_number: string,
   billing_details: IRequirementBillingDetails,
   job_type?: string,
   icon: string;
   user_id: string;
   user_name: string;
   user_email?: string;
   user_phone: string;
   profile_pic: string;
   createdAt: string;
   payment_status: string

};
interface DocumentDetails {
   worker_specialization?: string[]; // Array of worker specializations
   adhaar_number?: string; // Aadhaar number (optional, as it doesn't appear in all cases)
   pan_number?: string; // PAN number (optional)
   adhaar_front_pic?: string; // URL to Aadhaar front picture
   adhaar_back_pic?: string; // URL to Aadhaar back picture
   pan_front_pic?: string; // URL to PAN front picture
   firm_gst_number?: string; // GST number for the firm (optional)
   firm_pan_number?: string; // PAN number for the firm (optional)
   firm_gst_pic?: string; // URL to GST document picture for the firm
   firm_pan_pic?: string; // URL to PAN document picture for the firm
   firm_age?: string; // Age of the firm (optional)
   more_areas_served?: string; // Areas served (optional)
}

export interface IAppliedWorker {
   _id: string;
   worker_id: string;
   createdAt: string; // ISO Date string
   worker_name: string;
   worker_type: string;
   phone: string;
   sub_worker_type: string[]; // Array of sub-worker types
   profile_pic: string; // URL to profile picture
   is_verified: boolean;
   specifications: string[]; // Array of worker specifications
   average_ratings: number; // Decimal value for average ratings
   icon: string; // URL to worker's icon
   work_requirement: string[]; // Array of work requirements
   material_requirement: string[]; // Array of material requirements (empty here)
   hiring_type: string[]; // Array of hiring types (empty here)
   document_details: DocumentDetails;
}



// Requirement Values 

export interface IRequirementValues {
   _id: string;
   name: string;
   type: string;
   icon: string;
   description?: string;

}

//  User 
export interface IUser {
   _id: string;
   phone: string;
   otp: string;
   dial_code: string;
   is_otp_verified: boolean;
   is_user_details_completed: boolean;
   is_user_verified: boolean;
   address: {
      country: string;
      state: string;
      city: string;
      lat: number;
      long: number;
      pin_code: string;
      street: string;
      landmark: string;
   };
   name: string;
   email?: string;
   profile_pic: string;
   createdAt: string;

}

export interface FeatureDetail {
   _id: string;
   name: string;
   feature_id: string;
   description: string;
   createdAt: string;
   type: string;
   is_deleted: boolean;

}

export interface ISubscriptionPlans {

   _id: string;
   features: string[];
   isUnlimited: boolean;
   subscription_type: string;
   amount: string;
   subscription_text: string;
   subscription_duration: string;
   description_heading: string;
   background_color: string;
   icon: string;
   createdAt: string;
   updatedAt: string;
   __v: number;
   AllFeatures: FeatureDetail[];

}
export interface ISubscriptionFeature {
   _id: string; // Unique identifier
   name: string; // Name of the feature
   feature_id: string; // Feature identifier, often used as a key
   description: string; // Description of the feature
   createdAt: string; // ISO string representing the creation date
   updatedAt: string; // ISO string representing the last update date
   __v: number; // Versioning field (commonly used by MongoDB)
   type: string; // The type of the subscription (e.g., basic, premium, etc.)
   is_deleted: boolean; // Indicates if the feature is deleted
}

export interface IMembershipPlans {
   _id: string,
   plan_for: string,
   amount: string,
   membership_duration: string,
   membership_heading: string,
   membership_description: string[]
};

//  Help and Support 
export interface IHelpAndSupport {
   _id: string;
   customer_id: string;
   user_pic: string;
   is_resolved: boolean;
   worker_phone: number;
   user_phone: number;
   worker_pic: string;
   name: string;
   email: string;
   message: string;
   type: string;
   order: number;
   createdAt: string;
   updatedAt: string;
   __v: number;
}


//  worker Categories
export enum ECategory {
   SELLER = "seller",
   SALES_PROFESSIONAL = "sales_professional",
   WORKER_PROFESSIONAL = "worker_professional",
   BUSINESS_FIRM = "business_firm",
   ARCHITECT = "architect",
   ENGINEER = "engineer",
}


//  interface for Withdraw Request api
export interface IWithdrawReq {
   _id: string;
   worker_id: string;
   amount: number;         // Numeric value
   status: string;         // Status of the worker (e.g. pending)
   name: string;           // Name of the worker
   phone: string;          // Phone number of the worker
   worker_type: string;    // Type of worker (e.g. sales professional)
   profile_pic: string;    // URL of the profile picture
   createdAt: string;
   unique_code: string;
   worker_address: ILocation;
   bank_details: IBankDetails;
   unique_id: string;
   wallet_amount: number;
   lastPayDate: string;

}

//  interface for membership and subscription leads 
interface WorkerDetailsForLeads {
   _id: string;
   phone: string;
   name: string;
   profile_pic: string;
   worker_type: string;
}

interface SalesProfessionalDetails {
   _id: string;
   phone: string;
   name: string;
   profile_pic: string;
   sub_worker_type: string[];
   worker_type: string;
}

interface MembershipPlanDetails {
   _id: string;
   plan_for: string;
   amount: number;
   tax_percentage: number;
}
interface SubscriptionDetails {
   _id: string;
   amount: number;
   subscription_duration: string;
   subscription_type: string;
   tax_percentage: number;
}

export interface MembershipAndSubscriptionDetails {
   _id: string;
   is_deleted: boolean;
   customer_type: string;
   service_type: string;
   customer_id: string;
   unique_id: string;
   membership_validity: string;
   payment_amount: number;
   payment_id: string;
   is_referralCode_used: boolean;
   used_referral_l1: string;
   used_referral_l2: string;
   payment_order_id: string;
   signature: string;
   is_active: boolean;
   membership_plan_id: string;
   service_plan_id: string;
   subscription_type: string;
   subscription_validity: string;
   createdAt: string;
   updatedAt: string;
   __v: number;
   workerDetails: WorkerDetails;
   SalesProfessionalL1: SalesProfessionalDetails;
   SalesProfessionalL2: SalesProfessionalDetails;
   planDetails: MembershipPlanDetails;
   subscriptionDetails: SubscriptionDetails
   payment_status: boolean;
   gstAmount: number;
   amountExcludingGST: number;
   salesCommitionL1: number;
   salesCommitionL2: number;
   gstOnYowsComm: number;
   yowsComm: number;
   salesL1CommPercent: number;
   salesL2CommPercent: number;
}

// interfaces for transaction section

interface DoorstepOrderDetails {
   _id: string;
   unique_code: string;
   service_id: string;
   service_title: string;
   service_category: string;
   date_time?: string;
   billing_details?: BillingDetails;
   order_type?: string;
   service_count?: number;
   unique_id: string;
   status: string;
   workerDetails?: WorkerDetailsForTransaction;
}
interface MemberAndSubsDetailsForTransaction {

   is_active: boolean;
   membership_validity: string;
   payment_amount: number;
   service_type: string
   _id: string;
   unique_id: string;
   order_id: string;
   order_name: string;
   order_type: string;
   payment_id: string;
   payment_order_id: string;
   signature: string;
   status: boolean;
   updatedAt: string;
   workerDetails: WorkerDetailsForTransaction;
   SalesProfessionalL1: SalesProfessionalDetails;
   SalesProfessionalL2: SalesProfessionalDetails;
   gstAmount: number;
   amountExcludingGST: number;
   salesCommitionL1: number;
   salesCommitionL2: number;
   gstOnYowsComm: number;
   yowsComm: number;
   is_referralCode_used: boolean;
   salesL1CommPercent: number;
   salesL2CommPercent: number;
}
interface WorkerDetailsForTransaction {
   _id: string;
   phone: string;
   name: string;
   profile_pic: string;
   worker_id: string;
   __v: number;
}


interface JobDetailsForTransac {
   billing_details: IRequirementBillingDetails;
   createdAt: string;
   hiring_type: string[];
   salary_offered: string;
   type: string;
   unique_code: string;
   vacancy_count: number
   _id: string;
   unique_id: string;
}
interface WithdrawalDetails {
   _id: string;
   amount: number;
   status: "completed" | "pending" | "failed"; // Add other possible statuses if needed
   unique_id: string;
   createdAt: string; // Keeping it as string since it's an ISO date
}


export interface ITransactions {
   _id: string;
   order_name: string;
   payment_id: string;
   payment_order_id: string;
   signature: string;
   order_id: string;
   order_type: string;
   user_id: string;
   customer_type: string;
   payment_amount: number;
   status: string;
   createdAt: string;
   updatedAt: string;
   __v: number;
   unique_id: string;
   userDetails?: UserDetails;
   doorstepOrderDetails?: DoorstepOrderDetails;
   membershipAndSubscriptionsDetails: MemberAndSubsDetailsForTransaction;
   workerDetails?: WorkerDetailsForTransaction;
   jobDetails?: JobDetailsForTransac;
   withdrawalDetails?: WithdrawalDetails;



}

// Interface for the first worker
export interface IWorkerEarnings {
   // below types for doorsetp earnings
   _id: string;
   unique_code: string;
   assigned_worker: string;
   end_time: string;
   service_charges: number;
   amount_paid_online: number;
   convertedDate: string;
   worker_commision: string;

   // below types for Sales professions leads earnings

   sales_professional_code: string;
   sales_professional_id: string;
   worker_id: string;
   membership_type: string;
   commision: number;
   is_lead_matured: boolean;
   is_deleted: boolean;
   createdAt: string;
   updatedAt: string;
   __v: number;
   membership_details_id: string;
   service_type: string;
   subscription_type: string;
   service_title: string;
   service_count: number;
   Worker: IWorker;
   User: IUser;
}


//  Interface for Ratings 

export interface IWorkerRatings {
   _id: string; // The unique identifier for the order
   doorstep_service_id: string; // The ID of the related doorstep service
   user_email: string,
   worker_name: string;
   worker_pic: string;
   worker_phone: string;
   worker_verified: boolean;
   user_phone: string,
   service_icon: string,
   service_title: string,
   comment: string; // User's comment or review
   rating: number; // Numeric rating given by the user
   rating_type: string; // Type of rating (e.g., professionalServiceRatings)
   doorstep_order_id: string; // The ID of the related order
   createdAt: string; // ISO timestamp for when the order was created
   user_name: string; // Name of the user who placed the order
   user_pic: string; // URL of the user's profile picture
}
